import { Link } from "react-router-dom";
import { Seo, ORG_LD, breadcrumbLd } from "@/site/seo";
import { ABOUT, SITE } from "@/site/content";
import ApertureBackdrop from "@/site/components/ApertureBackdrop";

const GAP = 56;


export default function AboutPage() {
  return (
    <>
      <Seo title="About" description="Why Postern exists, what we believe about post-sale revenue, and the name." jsonLd={[ORG_LD, breadcrumbLd([{ name: "Home", path: "/" }, { name: "About", path: "/about" }])]} />
      <section className="section about" style={{ position: "relative", overflow: "hidden" }}>
        <ApertureBackdrop />
        <div className="wrap" style={{ maxWidth: 760, position: "relative", zIndex: 1 }}>
          <div>
            <h1 className="eyebrow" style={{ margin: "0 0 14px" }}>Postern</h1>
            <p className="lede serif" style={{ fontSize: 19, margin: 0 }}>{ABOUT.story}</p>
          </div>

          <div style={{ marginTop: GAP }}>
            <div className="eyebrow" style={{ margin: "0 0 14px" }}>Why we're doing this</div>
            <p className="lede serif" style={{ fontSize: 19, margin: 0 }}>{ABOUT.why}</p>
          </div>

          <div style={{ marginTop: GAP }}>
            <div className="eyebrow" style={{ margin: "0 0 14px" }}>Team</div>
            <p className="lede serif" style={{ fontSize: 19, margin: 0 }}>You will work directly with the people who built it. No account rep, no support queue — from your first call through setup.</p>
            <div style={{ marginTop: 28, display: "flex", flexWrap: "wrap", gap: 12 }}>
              <Link className="btn btn--primary" to="/contact">Talk to us →</Link>
              {SITE.email && <a className="btn btn--ghost" href={`mailto:${SITE.email}`}>{SITE.email}</a>}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
